import { Card as AntdCard } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type CardProps = Partial<GetProps<typeof AntdCard>>;
export type CardMetaProps = Partial<GetProps<typeof AntdCard.Meta>>;

export const cardPrefixCls = `${CMP_PREFIX}-card`;

export const Card = ({ ...props }: CardProps) => {
  return <AntdCard {...props} />;
};

export const CardMeta = ({ ...props }: CardMetaProps) => {
  return <AntdCard.Meta {...props} />;
};
